var enterpriseList = [
    {
        path: '/priseSlaughter',
        name: 'priseSlaughter',
        meta: {
            activeNav: 'priseSlaughterIndex',
        },
        component: () => import('../views/enterprise/index.vue')
    }, {
        path: '/priseTraceInfo',
        name: 'priseTraceInfo',
        meta: {
            activeNav: 'souceIndex',
        },
        component: () => import('../views/enterprise/traceInfo.vue')
    },
    {
        path: '/souceIndex',
        name: 'souceIndex',
        meta: {
            activeNav: 'souceIndex',
        },
        component: () => import('../views/enterprise/souceIndex.vue')
    },
  
]
export default enterpriseList